export default class ParallaxStop {
    constructor(element) {
        this.element = element;

        this.stopPosition = parseFloat(this.element.dataset?.parallaxStopY);
        this.contentOffset = this.element.dataset?.parallaxContentOffset ?? '100%';

        this.sticky = this.element.querySelector(this.element.dataset?.parallaxSticky);
        this.content = this.element.querySelector(this.element.dataset?.parallaxContent);

        // this.measure = this.measure.bind(this);
        this.measurements = null;

        if (!this.isValid()) {
            console.warn('Invalid Parallax Stop configuration for element', {
                element: this.element,
                stopPosition: this.stopPosition,
                stickyElement: this.sticky,
                contentElement: this.content,
            });
        }

        // this.init();
    }

    isValid() {
        return !isNaN(this.stopPosition) && this.sticky && this.content;
    }

    resetForMeasure() {
        [
            '--sticky-offset-margin',
            '--parent-offset-margin',
            '--parent-height',
            '--stop-line-position',
            '--content-initial-offset',
            '--debug-sticky-height',
            '--debug-content-height',
            '--debug-viewport-height',
        ].forEach(property => {
            this.element.style.removeProperty(property);
        });
    }

    getContentOffsetPixels(stickyHeight) {
        const value = String(this.contentOffset).trim();

        if (value.endsWith('%')) {
            return stickyHeight * (parseFloat(value) / 100);
        }

        if (value.endsWith('px')) {
            return parseFloat(value);
        }

        // Fallback: treat unitless numbers as px.
        return parseFloat(value) || stickyHeight;
    }

    measure() {
        this.element.dataset.componentParallaxStopInitialized = 'true';

        const viewportHeight = window.innerHeight;
        const stickyHeight = this.sticky.getBoundingClientRect().height;

        const stopLineY = stickyHeight * this.stopPosition;
        const contentHeight = this.content.scrollHeight;

        const initialContentOffset = this.getContentOffsetPixels(stickyHeight);

        const parentHeight = initialContentOffset + contentHeight;

        const stickyOffsetMargin = contentHeight - (stickyHeight - stopLineY);
        const parentOffsetMargin = Math.max(stickyOffsetMargin * -1, 0);

        this.measurements = {
            stickyHeight,
            contentHeight,
            viewportHeight,
            stopLineY,
            initialContentOffset,
            parentHeight,
            stickyOffsetMargin,
            parentOffsetMargin,
        };

        // this.element.style.setProperty('--sticky-offset-margin', `${stickyOffsetMargin}px`);
        // this.element.style.setProperty('--parent-offset-margin', `${parentOffsetMargin}px`);
        // this.element.style.setProperty('--parent-height', `${parentHeight}px`);
        // this.element.style.setProperty('--stop-line-position', `${stopLineY}px`);
        // this.element.style.setProperty('--content-initial-offset', `${initialContentOffset}px`);
        //
        // // debug values
        // this.element.style.setProperty('--debug-sticky-height', `${stickyHeight}px`);
        // this.element.style.setProperty('--debug-content-height', `${contentHeight}px`);
        // this.element.style.setProperty('--debug-viewport-height', `${viewportHeight}px`);
    }

    applyMeasurements() {
        if (!this.measurements) return;

        Object.entries({
            '--sticky-offset-margin': this.measurements.stickyOffsetMargin,
            '--parent-offset-margin': this.measurements.parentOffsetMargin,
            '--parent-height': this.measurements.parentHeight,
            '--stop-line-position': this.measurements.stopLineY,
            '--content-initial-offset': this.measurements.initialContentOffset,
            '--debug-sticky-height': this.measurements.stickyHeight,
            '--debug-content-height': this.measurements.contentHeight,
            '--debug-viewport-height': this.measurements.viewportHeight,
        }).forEach(([property, value]) => {
            this.element.style.setProperty(property, `${value}px`);
        });

    }

    waitForImages() {
        const images = [...this.element.querySelectorAll('img')];

        return Promise.all(
            images.map(img => {
                if (img.complete) return Promise.resolve();

                if (img.decode) {
                    return img.decode().catch(() => {});
                }

                return new Promise(resolve => {
                    img.addEventListener('load', resolve, { once: true });
                    img.addEventListener('error', resolve, { once: true });
                });
            })
        );
    }
}